import React from "react";

const UNDERLINE_DRAW_DURATION_MS = 900;
const UNDERLINE_INITIAL_DELAY_MS = 350;

const getSequenceDelayMs = (sequence) => (
  UNDERLINE_INITIAL_DELAY_MS + Math.max(0, sequence - 1) * UNDERLINE_DRAW_DURATION_MS
);

const HandDrawnUnderline = ({ children, className = "", sequence = 1, double = false }) => (
  <span
    className={[
      "landing-v2-hand-underline",
      double ? "landing-v2-hand-underline--double" : "",
      className,
    ].filter(Boolean).join(" ")}
    style={{ "--hand-underline-delay": `${getSequenceDelayMs(sequence)}ms` }}
  >
    {children}
    <svg
      className="landing-v2-hand-underline__svg"
      viewBox={double ? "0 0 120 14" : "0 0 120 10"}
      preserveAspectRatio="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        className="landing-v2-hand-underline__path"
        pathLength="100"
        d={double
          ? "M2 5.4 C 34 2.8 62 2.6 92 4.8 C 104 5.6 112 4 118 4.9"
          : "M2 7.6 C 34 4.4 62 4.2 92 6.2 C 104 7 112 5.4 118 6.3"}
      />
      {double ? (
        <path
          className="landing-v2-hand-underline__path landing-v2-hand-underline__path--second"
          pathLength="100"
          d="M3 10.4 C 36 8.2 64 8 90 9.8 C 106 10.6 110 9.2 117 10"
        />
      ) : null}
    </svg>
  </span>
);

export default HandDrawnUnderline;
